import React from 'react';

import { Link, Text } from '@change/ds-core-ui/next';

import { TranslateHtml } from '@change-corgi/core/react/i18n';

import { usePolicyInfo } from './hooks/usePolicyInfo';

type Props = {
	useDonationLanguage: boolean;
};

export function PolicyInfo({ useDonationLanguage }: Props): React.JSX.Element {
	const {
		data: { termsOfServiceLink, termsOfServiceLinkText, privacyPolicyLink, privacyPolicyLinkText, policyInfoText },
	} = usePolicyInfo({ useDonationLanguage });

	return (
		<Text as="span" variant="body" className="text-typography-strong text-size-body-xs md:text-size-body-small">
			<TranslateHtml
				value={policyInfoText}
				replacements={{
					termsOfServiceLink: (
						<Link href={termsOfServiceLink} target="_blank" rel="noreferrer" data-qa="terms-of-service-link">
							<Text variant="body" className="text-size-body-xs md:text-size-body-small">
								{termsOfServiceLinkText}
							</Text>
						</Link>
					),
					termsOfServiceLinkText,
					privacyPolicyLink: (
						<Link href={privacyPolicyLink} target="_blank" rel="noreferrer" data-qa="privacy-policy-link">
							<Text variant="body" className="text-size-body-xs md:text-size-body-small">
								{privacyPolicyLinkText}
							</Text>
						</Link>
					),
					privacyPolicyLinkText,
				}}
			/>
		</Text>
	);
}
